import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import BrainstormView from '../views/BrainstormView.vue'
import StudentAssignmentsView from '../views/StudentAssignmentsView.vue'
import TeacherDashboardView from '../views/TeacherDashboardView.vue'
import TeacherRecordView from '../views/TeacherRecordView.vue'
import AdminDashboardView from '../views/AdminDashboardView.vue'
import LoginView from '../views/LoginView.vue'
import ForbiddenView from '../views/ForbiddenView.vue'
import AccountEmailVerifyView from '../views/AccountEmailVerifyView.vue'
import PasswordResetView from '../views/PasswordResetView.vue'

export function roleHomePath(role) {
  if (role === 'teacher') return '/teacher'
  if (role === 'admin') return '/admin'
  return '/student/task'
}

const routes = [
  { path: '/student/experiments/:participantId', component: () => import('../experiments/ExperimentFlow.vue'), meta: { requiresAuth: true, roles: ['student'] } },
  { path: '/admin/experiments', component: () => import('../experiments/ExperimentAdmin.vue'), meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/account/verify-email', component: AccountEmailVerifyView, meta: { public: true, accountLink: true } },
  { path: '/account/reset-password', component: PasswordResetView, meta: { public: true, accountLink: true } },
  { path: '/', redirect: '/student/task' },
  { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
  { path: '/forbidden', name: 'forbidden', component: ForbiddenView, meta: { requiresAuth: true } },
  { path: '/student/task', component: StudentAssignmentsView, meta: { requiresAuth: true, roles: ['student'] } },
  { path: '/student/assignments', redirect: '/student/task' },
  { path: '/student/task/:assignmentId/workspace', component: BrainstormView, meta: { requiresAuth: true, roles: ['student'] } },
  { path: '/student/assignments/:assignmentId/workspace', redirect: to => `/student/task/${to.params.assignmentId}/workspace` },
  {
    path: '/assignments/:assignmentId',
    redirect: to => `/student/task/${to.params.assignmentId}/workspace`,
  },
  { path: '/teacher', component: TeacherDashboardView, meta: { requiresAuth: true, roles: ['teacher'] } },
  { path: '/teacher/records/:recordId', component: TeacherRecordView, meta: { requiresAuth: true, roles: ['teacher'] } },
  { path: '/admin', component: AdminDashboardView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/admin/records/:recordId', component: TeacherRecordView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/brainstorm', redirect: '/student/task' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.loadCurrentUser()
  if (to.name === 'login' && auth.isAuthenticated) {
    const next = typeof to.query.next === 'string' ? to.query.next : ''
    return isSafeInternalPath(next) && routeAllowsRole(next, auth.role) ? next : roleHomePath(auth.role)
  }
  if (!to.meta.requiresAuth) return true
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } }
  }
  if (Array.isArray(to.meta.roles) && !to.meta.roles.includes(auth.role)) {
    return { name: 'forbidden' }
  }
  return true
})

function routeAllowsRole(path, role) {
  const resolved = router.resolve(path)
  const roles = resolved.meta.roles
  return !Array.isArray(roles) || roles.includes(role)
}

function isSafeInternalPath(path) {
  return path.startsWith('/') && !path.startsWith('//')
}

export default router
